export default __webpack_public_path__ + "static/media/refresh.04ea0ecf.svg";